import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HomePageRoutingModule } from './home-routing.module';
import { SwiperModule } from 'swiper/angular';
import { GoogleMapsModule } from '@angular/google-maps';
import { CustomPipesModule } from 'src/app/pipes/pipes.module';

import { HomePage } from './home.page';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
// import { SafePipe } from 'src/app/pipes/dom-sanitizer/dom-sanitizer.pipe';
import {
  canActivate,
  customClaims,
  redirectUnauthorizedTo,
} from '@angular/fire/auth-guard';
import { SharedModule } from 'src/app/components/shared/shared.module';

// const redirectAuthorizedToHome = () =>
//   pipe(
//     customClaims,
//     map((claims) => {
//       if (claims.role) {
//         return ['home'];
//       }
//       return true;
//     })
//   );

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomePageRoutingModule,
    SwiperModule,
    GoogleMapsModule,
    CustomPipesModule,
    SharedModule
  ],
  declarations: [HomePage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomePageModule {}
